<template>
  <div class=" overflow-y-auto bg-gray-50 px-4 pt-6 mb-10" dir="rtl">
    <div class="max-w-lg mx-auto flex flex-col">
      <div ref="form">
        <div>
          <ul class="relative request_detail_ul">
            <!--            *****************************-->
            <li v-if="pageLoading || hasValue(request_info.LastStatus) || hasValue(request_info.RequestCode) || hasValue(request_info.RequestName)">
              <div class="flex flex-col gap-2.5 w-full">
                <div v-if="pageLoading || hasValue(request_info.LastStatus) || hasValue(request_info.RequestCode)" class="flex items-center justify-between w-full gap-3 flex-wrap">
                  <span v-if="pageLoading || hasValue(request_info.LastStatus)" class="request-detail-meta">
                    <svg class="request-detail-meta__icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                    <span v-if="pageLoading" class="skeleton-block skeleton-line skeleton-line-md"></span>
                    <span v-else>{{ request_info.LastStatus }}</span>
                  </span>
                  <span v-if="pageLoading || hasValue(request_info.RequestCode)" class="request-detail-meta request-detail-meta--mono">
                    <span v-if="pageLoading" class="skeleton-block skeleton-line skeleton-line-sm"></span>
                    <span v-else>{{ request_info.RequestCode }}</span>
                  </span>
                </div>
                <div v-if="pageLoading || hasValue(request_info.RequestName)" class="request-detail-meta">
                  <svg class="request-detail-meta__icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <span v-if="pageLoading" class="skeleton-block skeleton-line skeleton-line-lg"></span>
                  <span v-else>{{ request_info.RequestName }}</span>
                </div>
              </div>
            </li>

            <li
              v-if="request_info_loaded && (request_info.IsCompany == 1 || request_info.IsCompany == '1')"
              class="request-detail-alert-company"
            >
              مشتری درخواست فاکتور رسمی دارد
            </li>

            <li v-if="pageLoading || (request_info_loaded && !dialog_accept_refer && hasValue(request_info.LastTechStatus))" class="flex items-center justify-between gap-3">
              <label class="mb-0">آخرین وضعیت</label>
              <span v-if="pageLoading" class="skeleton-block skeleton-line skeleton-line-value"></span>
              <span v-else>{{ lastTechStatusWithTime }}</span>
            </li>

            <li v-if="pageLoading || (request_info_loaded && request_info.TotalAmount != null && request_info.TotalAmount !== '')">
              <label>مبلغ فاکتور دریافتی</label>
              <span>
                <span v-if="pageLoading" class="skeleton-block skeleton-line skeleton-line-value"></span>
                <template v-else>{{ request_info.TotalAmount }}</template>
                <span style="font-size: 10px;">تومان</span>
              </span>
            </li>
            
            <li v-if="pageLoading || hasValue(request_info.BranchName)">
              <label>شعبه:</label>
              <span v-if="pageLoading" class="skeleton-block skeleton-line skeleton-line-value"></span>
              <span v-else>
                {{ request_info.BranchName }}
              </span>
            </li>

           

       

            <!--*****************************-->
            <li v-if="pageLoading || hasValue(request_info.ExpertName)">
              <label>{{ $t('expertReceiptQ') }}</label>
              <span v-if="pageLoading" class="skeleton-block skeleton-line skeleton-line-value"></span>
              <span v-else>
                {{ request_info.ExpertName }}
              </span>
            </li>


            <li v-if="pageLoading || hasValue(request_info.DevicePass)">
              <label>{{ $t('devicePasswordQ') }}</label>
              <span v-if="pageLoading" class="skeleton-block skeleton-line skeleton-line-sm"></span>
              <span v-else>
                {{ request_info.DevicePass }}
              </span>
            </li>


            <li v-if="pageLoading || hasValue(request_info.AppearanceProblem)">
              <label>{{ $t('appearanceProblemQ') }}</label>
              <span v-if="pageLoading" class="skeleton-block skeleton-line skeleton-line-lg"></span>
              <span v-else>
                {{ request_info.AppearanceProblem }}
              </span>
            </li>


            <li v-if="pageLoading || hasValue(request_info.CustomerMobile)">
              <label>{{ $t('phoneNoQ') }}</label>
              <span v-if="pageLoading" class="skeleton-block skeleton-line skeleton-line-value"></span>
              <span v-else>
                <a :href="'tel:' + request_info.CustomerMobile" class="text-blue-600">
                  {{ request_info.CustomerMobile }}
                </a>
              </span>
            </li>


            <li v-if="pageLoading || hasValue(request_info.ExpertOpinion)">
              <label>{{ $t('ExpertOpinionQ') }}</label>
              <span v-if="pageLoading" class="skeleton-block skeleton-line skeleton-line-lg"></span>
              <span v-else>
                {{ request_info.ExpertOpinion }}
              </span>
            </li>
            

            <li v-if="pageLoading || hasValue(request_info.PredefinedGlobal) || hasValue(request_info.PredefinedChecked)">
              <label>{{ $t('predefinedTagsQ') }}</label>
              <div class="text-right">
                <template v-if="pageLoading">
                  <span
                    v-for="n in 3"
                    :key="'tag-sk-' + n"
                    class="skeleton-block skeleton-chip ml-1.5 mb-1.5"
                  ></span>
                </template>
                <template v-else>
                  <span v-for="item in request_info.PredefinedGlobal" :key="item.Text"
                    class="inline-block bg-blue-50 text-blue-700 text-xs px-3 py-1 rounded-lg border border-blue-200 ml-1.5 mb-1.5">
                    {{ item.Text }}:{{ item.Value }}
                  </span>

                  <span v-for="item in request_info.PredefinedChecked" :key="item.Text"
                    class="inline-block bg-blue-50 text-blue-700 text-xs px-3 py-1 rounded-lg border border-blue-200 ml-1.5 mb-1.5">
                    {{ item.Text }}:{{ item.Value }}

                  </span>
                </template>
              </div>
            </li>

            <li v-if="safeParseArray(request_info.EjraiStatusSummary).length">
              <label>{{ $t('referDescriptionQ') }}</label>

              <div v-for="ejraii in safeParseArray(request_info.EjraiStatusSummary)"
                :key="ejraii.StatusName + ejraii.Summary">
                {{ ejraii.StatusName }} : {{ ejraii.Summary }}
              </div>

            </li>

            <li v-if="pageLoading || (request_info_loaded && !dialog_accept_refer && hasValue(request_info.CurrentStatus))" class="flex items-center justify-between gap-3">
              <label class="mb-0">وضعیت دستگاه:</label>
              <span v-if="pageLoading" class="skeleton-block skeleton-line skeleton-line-value"></span>
              <span v-else>{{ request_info.CurrentStatus }}</span>
            </li>

            <li v-if="pageLoading || hasValue(request_info.TechPriceRange)">
              <label>{{ $t('priceRangeQ') }}</label>

              <span>
                <span v-if="pageLoading" class="skeleton-block skeleton-line skeleton-line-value"></span>
                <template v-else>{{ request_info.TechPriceRange }}</template>
                <span style="font-size: 10px;">تومان</span>
              </span>
            </li>

            <li v-if="pageLoading || hasValue(request_info.Summary)">
              <label>{{ $t('summary') }}:</label>

              <span v-if="pageLoading" class="skeleton-block skeleton-line skeleton-line-lg"></span>
              <span v-else>
                {{ request_info.Summary }}
              </span>
            </li>
            
            
            <li v-if="pageLoading || (request_info_loaded && !dialog_accept_refer && hasValue(request_info.Addresses))">
              <div class="pa-1">
                <label>{{ $t('addressesQ') }}</label>
                <div v-if="pageLoading">
                  <div class="skeleton-block skeleton-line skeleton-line-full mb-2"></div>
                  <div class="skeleton-block skeleton-line skeleton-line-lg"></div>
                </div>
                <template v-else>
                  <div v-for="item in request_info.Addresses" :key="item.AddressId || item.Lat" class="">
                    <div class="address-text">{{ item.CityName }} - {{ item.AreaName }} {{ item.AddressText }}</div>
                    <div class="flex gap-2 mt-2">
                      <button v-if="item.Lat != null" class="flex-1 flex items-center justify-center gap-2 py-3 px-4 bg-blue-50 hover:bg-blue-100 active:bg-blue-200 border border-blue-200 text-blue-700 rounded-lg font-semibold transition-all duration-200" @click="go_direction(item, 1)">
                        <img src="/img/svg/BaiduMap.svg" alt="Google Maps" class="w-5 h-5" />
                        <span class="text-sm">{{ $t('navigation') }}</span>
                      </button>
                      <button v-if="item.Lat != null" class="flex-1 flex items-center justify-center gap-2 py-3 px-4 bg-blue-50 hover:bg-blue-100 active:bg-blue-200 border border-blue-200 text-blue-700 rounded-lg font-semibold transition-all duration-200" @click="go_direction(item, 2)">
                        <img src="/img/svg/Waze.svg" alt="Waze" class="w-5 h-5" />
                        <span class="text-sm">ویز</span>
                      </button>
                      <button v-if="item.Lat != null" class="flex-1 flex items-center justify-center gap-2 py-3 px-4 bg-blue-50 hover:bg-blue-100 active:bg-blue-200 border border-blue-200 text-blue-700 rounded-lg font-semibold transition-all duration-200" @click="go_direction(item, 3)">
                        <img src="/img/svg/Neshan.svg" alt="Neshan" class="w-5 h-5" />
                        <span class="text-sm">نشان</span>
                      </button>
                    </div>
                  </div>
                </template>
              </div>
            </li>
           
            <li v-if="pageLoading || safeParseArray(request_info.OtherReqCode).length">
              <label>درخواست های مشترک:</label>
              <div v-if="pageLoading" class="flex flex-wrap gap-2 text-left ltr">
                <span class="skeleton-block skeleton-line skeleton-line-sm"></span>
                <span class="skeleton-block skeleton-line skeleton-line-sm"></span>
              </div>
              <div v-else class="flex flex-wrap gap-2 text-left ltr">
                <span class="font-mono" v-for="item in safeParseArray(request_info.OtherReqCode)" :key="item.RequestCode">
                  {{ item.RequestCode }}
                </span>
              </div>
            </li>
            <li v-if="pageLoading || hasValue(request_info.SummaryLocal)">
              <label>توضیحات داخلی:</label>
              <span v-if="pageLoading" class="skeleton-block skeleton-line skeleton-line-lg"></span>
              <span v-else>
                {{ request_info.SummaryLocal }}
              </span>
            </li>
          </ul>

        </div>
        <div>
          <div v-if="request_info_loaded && dialog_accept_refer" class="inline-refer-card">
            <div class="inline-refer-header">درخواست ارجاعی</div>
            <div class="inline-refer-body">
              <input v-model="req_tech_refer_summary" class="plain-input mb-2" placeholder="توضیحات" />
              <div class="mb-2">آیا دریافت این درخواست ارجاعی را تایید می‌کنید؟</div>
              <div class="flex gap-2 items-center justify-center" v-if="!show_reject_area">
                <button class="btn-accept w-full" @click="accept_refer_tech(1)">قبول درخواست</button>
                <button class="btn-reject w-full" @click="show_reject_area = true">رد درخواست</button>
              </div>
              <div v-if="show_reject_area" class="mt-3">
                <input v-model="req_tech_refer_summary" class="plain-input" placeholder="دلیل رد ارجاع" />
                <div class="btn-row mt-2">
                  <button class="btn-reject" @click="accept_refer_tech(0)">تایید رد ارجاع</button>
                  <button class="secondary-btn" @click="show_reject_area = false">انصراف</button>
                </div>
              </div>
            </div>
          </div>

          <div v-if="pageLoading || attachmentsLoading || (request_info_loaded && !dialog_accept_refer && attachment_items.length)" class="bg-white border border-gray-200 rounded-xl p-3 mb-3">
            <div class="text-sm font-bold text-gray-700 mb-3">پیوست‌های درخواست</div>
            <div v-if="pageLoading || attachmentsLoading" class="grid grid-cols-3 md:grid-cols-4 gap-2">
              <div
                v-for="n in skeletonThumbCount"
                :key="'vr-att-' + n"
                class="skeleton-block skeleton-thumb"
              ></div>
            </div>
            <div v-else class="grid grid-cols-3 md:grid-cols-4 gap-2">
              <button
                v-for="(item, index) in attachment_items"
                :key="item.Id || item.ImagePath"
                type="button"
                class="group text-right"
                @click="open_image(index)"
              >
                <div class="aspect-square rounded-lg overflow-hidden bg-gray-100 border border-gray-200">
                  <img :src="item.ImagePath" :alt="item.ImageName || 'attachment'" class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200" />
                </div>
                <p class="text-11px text-gray-700 truncate mt-1">{{ item.ImageName || 'پیوست' }}</p>
              </button>
            </div>
          </div>

          <div class="actions-grid" v-if="request_info_loaded && !dialog_accept_refer">
            <button v-if="action_button_text != ''" class="primary-btn" @click="go_to_categories()">{{
              action_button_text }}</button>
            <a v-if="action_button_text != ''" :href="'tel:' + request_info.CustomerMobile"
              class="primary-btn text-center">{{ $t('callToCustomer') }}</a>
            <template v-if="request_info.StatusId == 15">
              <button class="primary-btn" @click="change_predefined()">تغییر لوازم همراه</button>
              <button class="primary-btn" @click="change_request_status(17)">تایید دریافت از مشتری</button>
            </template>
            <template
              v-if="request_info.StatusId == request_statuses[5] || request_info.StatusId == request_statuses[16]">
              <button class="primary-btn" @click="tickets_dialog = true">{{ $t('tickets') }}</button>
              <button class="primary-btn" @click="go_to_messages()">پیام ها</button>
              <button class="primary-btn">{{ $t('preFactors') }}</button>
              <button class="primary-btn" @click="go_to_goods_factors()">{{ $t('productRequests') }}</button>
              <button class="primary-btn" @click="go_to_informher_masters()">{{ $t('customerInformHer') }}</button>
              <button v-if="showOnlineFactorBtn" class="primary-btn" @click="go_to_online_factor()">فاکتور آنلاین</button>
              <button class="primary-btn" @click="change_status_dialog = true">{{ $t('changeStatusRequest') }}</button>
              <button class="primary-btn" @click="go_to_qc()">{{ $t('qc') }}</button>
              <button
                v-if="showSendBranchAddressBtn"
                class="primary-btn primary-btn--wide"
                @click="send_branch_address()"
              >ارسال آدرس شعبه</button>

            </template>
          </div>
        </div>
      </div>



    </div>
    <!-- Change Status Modal -->
    <div v-if="change_status_dialog" class="fixed inset-0 bg-black bg-opacity-50 z-999 flex items-center justify-center p-4">
      <div class="bg-white rounded-xl shadow-xl w-full max-w-2xl max-h-90vh overflow-hidden flex flex-col">
        <!-- Header -->
        <div class="px-6 py-4 bg-gradient-to-r from-blue-600 to-blue-700">
          <h2 class="text-lg font-bold text-white">{{ $t('changeStatusRequest') }}</h2>
        </div>

        <!-- Body -->
        <div class="px-6 py-4 overflow-y-auto flex-1 space-y-4">
          <!-- Status Select -->
          <div class="relative">
            <label class="block text-sm font-medium text-gray-700 mb-2">وضعیت جدید</label>
            <div class="relative">
              <select 
                v-model="selected_status_for_change" 
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 appearance-none pr-10"
                style="border: 1px solid #d1d5db !important;"
              >
                <option :value="0" disabled>{{ $t('NewStatusChangeStatus') }}</option>
                <option v-for="opt in status_list_items" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
              </select>
              <!-- Dropdown Icon -->
              <div class="absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
                <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>
          </div>

          <!-- Price Input (conditional) -->
          <div v-if="selected_status_for_change == 52 || selected_status_for_change == 83 || selected_status_for_change == 88">
            <label class="block text-sm font-medium text-gray-700 mb-2">مبلغ</label>
            <input 
              v-model="change_status_price" 
              type="tel"
              inputmode="numeric"
              pattern="[0-9]*"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              style="border: 1px solid #d1d5db !important;"
              placeholder="مثلاً 1,000,000"
            />
          </div>

          <!-- Summary Textarea -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">توضیحات</label>
            <textarea 
              rows="4" 
              v-model="change_status_summary"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
              style="border: 1px solid #d1d5db !important;"
              :placeholder="$t('insertChangeStatusSummary')"
            ></textarea>
          </div>
        </div>

        <!-- Footer -->
        <div class="px-6 py-4 border-t border-gray-200 flex gap-3">
          <button 
            class="flex-1 px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-colors duration-200"
            @click="change_status_dialog = false"
          >
            {{ $t('cancel') }}
          </button>
          <button 
            class="flex-1 px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-medium rounded-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
            :disabled="selected_status_for_change == 0"
            @click="change_tech_status()"
          >
            {{ $t('ok') }}
          </button>
        </div>
      </div>
    </div>

    <div v-if="tickets_dialog" class="plain-dialog">
      <div class="dialog-card">
        <div class="dialog-header">{{ $t('tickets') }}</div>
        <div class="dialog-body">
          <div v-for="(ticket, index) in request_info.Tickets" :key="'ticket' + index">{{ ticket }}</div>
        </div>
        <div class="dialog-actions">
          <button class="primary-btn" @click="tickets_dialog = false">{{ $t('close') }}</button>
        </div>
      </div>
    </div>
    <div v-if="returned_request" class="plain-dialog">
      <div class="dialog-card">
        <div class="dialog-header">هشدار</div>
        <div class="dialog-body">
          کاربر گرامی لطفا قبل از تایید دریافت، اقلام دستگاه مرجوعی را از منو تغییر اقلام همراه اعلام کنید، در غیر
          این صورت عواقب آن بر عهده شما می باشد
        </div>
        <div class="dialog-actions">
          <button class="primary-btn" @click="returned_request = false">تایید</button>
        </div>
      </div>
    </div>

    <div
      v-if="lightbox_image"
      class="request-lightbox fixed inset-0 bg-black bg-opacity-80 pt-4 pb-24 px-4 flex items-center justify-center overflow-hidden"
      @click="on_lightbox_backdrop_click($event)"
      @wheel.prevent="on_lightbox_wheel($event)"
      @touchstart="on_lightbox_touch_start($event)"
      @touchmove="on_lightbox_touch_move($event)"
      @touchend="on_lightbox_touch_end($event)"
    >
      <button
        v-if="attachment_items.length > 1"
        type="button"
        class="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white bg-opacity-20 hover:bg-white hover:bg-opacity-30 text-white text-2xl z-10"
        @click.stop="show_prev_image()"
      >
        ›
      </button>
      <button
        v-if="attachment_items.length > 1"
        type="button"
        class="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white bg-opacity-20 hover:bg-white hover:bg-opacity-30 text-white text-2xl z-10"
        @click.stop="show_next_image()"
      >
      ‹
      </button>
      <button
        type="button"
        class="absolute top-4 right-4 w-10 h-10 rounded-full bg-white bg-opacity-20 hover:bg-white hover:bg-opacity-30 text-white text-xl"
        @click.stop="close_lightbox()"
      >
        ×
      </button>
      <div class="request-lightbox__stage flex items-center justify-center max-w-full" @click.stop>
        <img
          :src="lightbox_image"
          class="request-lightbox__img max-w-full object-contain rounded-lg select-none"
          :style="lightbox_image_style()"
          draggable="false"
          @click.stop="on_lightbox_image_click()"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { bus } from '../../main.js'
import { skeletonSilentRequest } from '../../utils/skeletonPages'
import moment from 'moment-jalaali'

export default {
  props: [
    'passing_data'
  ],
  data() {
    return {
      returned_request: false,
      pageLoading: true,
      attachmentsLoading: true,
      skeletonThumbCount: 3,
      change_status_summary: '',
      change_status_price: '',
      dialog_accept_refer: false,
      request_info_loaded: false,
      show_reject_area: false,
      change_status_dialog: false,
      tickets_dialog: false,
      req_tech_refer_summary: "",
      status_list_items: [],
      selected_status_for_change: 0,
      errors: [],
      request_info: [],
      action_button_text: '',
      request_statuses: [],
      next_action_status: 0,
      branch_id: 0,

      technician_name: 'hamid mokhtari',
      device_password: 'hamid mokhtari',
      current_lat: '',
      current_lng: '',
      source_location_lat: '',
      source_location_lng: '',
      attachment_items: [],
      lightbox_image: '',
      lightbox_index: -1,
      lightbox_scale: 1,
      lightbox_translate_x: 0,
      lightbox_translate_y: 0,
      lightbox_touch_mode: '',
      lightbox_touch_start_x: 0,
      lightbox_pinch_start_distance: 0,
      lightbox_pinch_start_scale: 1,
      lightbox_pan_start_x: 0,
      lightbox_pan_start_y: 0,
      lightbox_pan_origin_tx: 0,
      lightbox_pan_origin_ty: 0,

    }
  },
  computed: {
    loggedInPhoneNormalized() {
      return this.normalizePhoneDigits(localStorage.getItem('phone'))
    },
    branchAddressUrlParam() {
      const phone = this.loggedInPhoneNormalized
      if (phone === '09128956883' || phone === '09125835104') return 'a44'
      if (phone === '09125380056') return 'a62'
      return ''
    },
    showSendBranchAddressBtn() {
      return !!this.branchAddressUrlParam
    },
    showOnlineFactorBtn() {
      const phone = this.loggedInPhoneNormalized
      return phone === '09012102177' || phone === '09109471396'
    },
    lastTechStatusWithTime () {
      var base = this.request_info && this.request_info.LastTechStatus != null
        ? String(this.request_info.LastTechStatus).trim()
        : ''
      if (!base) return ''
      var list = this.safeParseArray(this.request_info.EjraiStatusSummary)
      if (!list.length) return base
      var last = list[list.length - 1]
      var jalali = this.formatEjraiSubmitTimeJalali(last && last.SubmitTime)
      if (!jalali) return base
      var cleaned = base.replace(/[-\s]+$/g, '')
      return cleaned + '- ' + jalali
    },
  },
  watch: {
    selected_province: function () {
      this.get_cities()
    },
    change_status_price () {
      const formatted = this.formatAmountInput(this.change_status_price)
      if (this.change_status_price !== formatted) {
        this.change_status_price = formatted
      }
    },
  },
  mounted() {
    this.get_current_location()
    // var passing_data = JSON.parse(localStorage.getItem('request_data'));
    // this.enable_send_from_country = passing_data.on_site_service;
    // this.get_phone_prefix()
    // this.get_device_status()
    // this.get_provinces()
    this.get_stats_list()
    this.get_request_info()
    this.get_branch_permission()
  },
  methods: {
    finishInitialLoad() {
      if (this.pageLoading) {
        this.pageLoading = false
      }
    },
    hasValue(val) {
      if (val == null || val === '') return false
      if (typeof val === 'string' && val.trim() === '') return false
      if (Array.isArray(val) && val.length === 0) return false
      return true
    },
    safeParseArray(val) {
      try {
        if (!val) return []
        if (Array.isArray(val)) return val
        const parsed = JSON.parse(val)
        return Array.isArray(parsed) ? parsed : []
      } catch (e) {
        return []
      }
    },
    formatEjraiSubmitTimeJalali (submitTime) {
      if (submitTime == null || String(submitTime).trim() === '') return ''
      var value = String(submitTime).trim().replace(/\s+/g, ' ')
      var m = moment(value, ['DD-MM-YYYY HH mm', 'DD-MM-YYYY HH:mm', 'YYYY-MM-DD HH:mm:ss'], true)
      if (!m.isValid()) {
        m = moment(value, 'DD-MM-YYYY HH mm')
      }
      if (!m.isValid()) return ''
      return String(m.format('HH:mm jYYYY/jMM/jDD')).replace(/\d/g, function (d) {
        return '۰۱۲۳۴۵۶۷۸۹'[d]
      })
    },
    go_to_online_factor() {
      const obj = {
        req_code: this.request_info.RequestCode,
        req_name: this.request_info.RequestName,
        customer_mobile: this.request_info.CustomerMobile,
      }
      localStorage.setItem("online_factor_data", JSON.stringify(obj))
      // console.log('request_info',this.request_info)
      this.$router.push({ path: '/report-request/online-factor' })
    },
    go_to_messages() {
      const req_id = this.$route.params.rec_id
      const last_chat_detail = {
        RecType: 1,
        UserOrGroupId: req_id,
        GetReceiver: req_id
      }
      localStorage.setItem('lastChat', JSON.stringify(last_chat_detail))
      this.$router.push({ path: '/chat-detail', params: {} })
    },
    get_attachs() {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      const send_data = {
        UserId: user_id,
        ReqId: this.$route.params.rec_id,
        IsFinalize: 1,
      }
      this.axios.post('/GetUserRequestImages', send_data, skeletonSilentRequest)
        .then(response => {
          if (response.data.error == 0) {
            self.attachment_items = response.data.results || [];
            // Add https:// prefix if not present
            self.attachment_items.forEach(function(item) {
              if (item.ImagePath && !item.ImagePath.startsWith('http')) {
                item.ImagePath = 'https://' + item.ImagePath;
              }
            });
          }
          self.attachmentsLoading = false
        }).catch(e => {
          this.errors.push(e)
          this.attachmentsLoading = false
        })
    },
    open_image(index) {
      if (!this.attachment_items.length) return
      this.lightbox_index = index
      this.lightbox_image = this.attachment_items[index].ImagePath
      this.reset_lightbox_zoom()
    },
    close_lightbox() {
      this.lightbox_image = ''
      this.lightbox_index = -1
      this.reset_lightbox_zoom()
    },
    show_next_image() {
      if (!this.attachment_items.length) return
      this.lightbox_index = (this.lightbox_index + 1) % this.attachment_items.length
      this.lightbox_image = this.attachment_items[this.lightbox_index].ImagePath
      this.reset_lightbox_zoom()
    },
    show_prev_image() {
      if (!this.attachment_items.length) return
      this.lightbox_index = (this.lightbox_index - 1 + this.attachment_items.length) % this.attachment_items.length
      this.lightbox_image = this.attachment_items[this.lightbox_index].ImagePath
      this.reset_lightbox_zoom()
    },
    reset_lightbox_zoom() {
      this.lightbox_scale = 1
      this.lightbox_translate_x = 0
      this.lightbox_translate_y = 0
      this.lightbox_touch_mode = ''
    },
    lightbox_image_style() {
      const scale = this.lightbox_scale
      const tx = this.lightbox_translate_x
      const ty = this.lightbox_translate_y
      const base = {
        maxHeight: 'calc(100vh - 8rem)',
        transition: this.lightbox_touch_mode ? 'none' : 'transform 0.15s ease'
      }
      if (scale <= 1 && tx === 0 && ty === 0) {
        return { ...base, cursor: 'zoom-in' }
      }
      return {
        ...base,
        maxHeight: 'none',
        transform: `translate(${tx}px, ${ty}px) scale(${scale})`,
        transformOrigin: 'center center',
        cursor: this.lightbox_touch_mode === 'pan' ? 'grabbing' : 'grab'
      }
    },
    clamp_lightbox_scale(scale) {
      return Math.min(4, Math.max(1, scale))
    },
    set_lightbox_scale(scale) {
      const clamped = this.clamp_lightbox_scale(scale)
      if (clamped <= 1) {
        this.reset_lightbox_zoom()
        return
      }
      this.lightbox_scale = clamped
    },
    get_touch_distance(touches) {
      const dx = touches[0].clientX - touches[1].clientX
      const dy = touches[0].clientY - touches[1].clientY
      return Math.hypot(dx, dy)
    },
    on_lightbox_wheel(e) {
      if (!this.lightbox_image) return
      const step = e.deltaY < 0 ? 0.15 : -0.15
      this.set_lightbox_scale(this.lightbox_scale + step)
    },
    on_lightbox_backdrop_click(e) {
      if (e.target === e.currentTarget) {
        this.close_lightbox()
      }
    },
    on_lightbox_image_click() {
      if (this.lightbox_scale > 1) {
        this.reset_lightbox_zoom()
      } else {
        this.set_lightbox_scale(2)
      }
    },
    on_lightbox_touch_start(e) {
      if (e.touches.length === 2) {
        this.lightbox_touch_mode = 'pinch'
        this.lightbox_pinch_start_distance = this.get_touch_distance(e.touches)
        this.lightbox_pinch_start_scale = this.lightbox_scale
        return
      }
      if (e.touches.length !== 1) return
      if (this.lightbox_scale > 1) {
        this.lightbox_touch_mode = 'pan'
        this.lightbox_pan_start_x = e.touches[0].clientX
        this.lightbox_pan_start_y = e.touches[0].clientY
        this.lightbox_pan_origin_tx = this.lightbox_translate_x
        this.lightbox_pan_origin_ty = this.lightbox_translate_y
        return
      }
      this.lightbox_touch_mode = 'swipe'
      this.lightbox_touch_start_x = e.touches[0].clientX
    },
    on_lightbox_touch_move(e) {
      if (this.lightbox_touch_mode === 'pinch' && e.touches.length === 2) {
        e.preventDefault()
        const dist = this.get_touch_distance(e.touches)
        if (!this.lightbox_pinch_start_distance) return
        const ratio = dist / this.lightbox_pinch_start_distance
        this.set_lightbox_scale(this.lightbox_pinch_start_scale * ratio)
        return
      }
      if (this.lightbox_touch_mode === 'pan' && e.touches.length === 1) {
        e.preventDefault()
        const dx = e.touches[0].clientX - this.lightbox_pan_start_x
        const dy = e.touches[0].clientY - this.lightbox_pan_start_y
        this.lightbox_translate_x = this.lightbox_pan_origin_tx + dx
        this.lightbox_translate_y = this.lightbox_pan_origin_ty + dy
      }
    },
    on_lightbox_touch_end(e) {
      if (this.lightbox_touch_mode === 'pinch' || this.lightbox_touch_mode === 'pan') {
        if (!e.touches.length) {
          this.lightbox_touch_mode = ''
          if (this.lightbox_scale < 1.05) {
            this.reset_lightbox_zoom()
          }
        }
        return
      }
      if (this.lightbox_touch_mode !== 'swipe') return
      if (!e.changedTouches || !e.changedTouches.length) return
      this.lightbox_touch_mode = ''
      if (this.lightbox_scale > 1 || this.attachment_items.length <= 1) return
      const delta_x = e.changedTouches[0].clientX - this.lightbox_touch_start_x
      const swipe_threshold = 40
      if (Math.abs(delta_x) < swipe_threshold) return
      if (delta_x < 0) {
        this.show_next_image()
      } else {
        this.show_prev_image()
      }
    },
    change_predefined() {
      this.$router.push({ path: '/report-request/changed-predined-return/' + this.$route.params.rec_id })
    },
    go_direction(item, state) {
      // var url = 'geo:0,0?q=' + item.Lat + ',' + item.Lng
      // var url = 'https://www.google.com/maps/@' + item.Lat + ','+item.Lng+',17z'
      // var url = 'https://www.google.co.in/maps/dir/?saddr=&daddr=' + item.Lat + ',' + item.Lng + '&directionsmode=driving'
      var url = ""
      if (state == 1) {
        url = `https://maps.google.com/?q=${item.Lat},${item.Lng}`

      }
      if (state == 2) {
        url = `https://waze.com/ul?ll=${item.Lat},${item.Lng}&z=10`

      }
      if (state == 3) {
        url = `https://nshn.ir/?lat=${item.Lat}&lng=${item.Lng}`
      }

      // window.open(url, '_blank')
      window.open(url, '_blank')
    },
    get_request_info() {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      const send_data = {
        ExpertId: user_id,
        RequestId: this.$route.params.rec_id,
      }
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/GetRequestInfoByReqId', send_data, skeletonSilentRequest)
        .then(response => {
          if (response.data.error == 0) {
            self.request_info = response.data.rec
            const ar = self.request_info.AcceptRefer
            const pendingAccept = (ar == 10 || ar == "10") || (ar == null && self.request_info.StatusId == 12)
            self.dialog_accept_refer = !!pendingAccept
            self.request_info_loaded = true
            self.show_reject_area = false
            self.get_attachs()
            if (self.request_info.StatusId == 12 && !self.dialog_accept_refer) {

              self.returned_request = true;
            }
            this.get_device_status()
          } else {
            self.attachmentsLoading = false
          }
          self.finishInitialLoad()
          // this.$router.push({ path: "/post-login", params: {} });
        }).catch(e => {
          this.errors.push(e)
          this.attachmentsLoading = false
          this.finishInitialLoad()
        })
    },
    accept_refer_tech(status) {
      if (status == 0 && this.req_tech_refer_summary == "") {
        bus.$emit('show_toast', [2000, "توضیحات را وارد کنید"])
        return
      }
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      const send_data = {
        UserId: user_id,
        ProcessId: this.$route.params.rec_id,
        RecStatusId: this.request_info.RecStatusId,
        ProcessType: 1,
        ItemDesc: this.req_tech_refer_summary,
        AcceptType: status,
      }

      // this.axios.post('/Register' , send_data,{
      this.axios.post('/AddProcessReferAccept', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            self.get_request_info()
            self.dialog_accept_refer = false;
            if (status == 0) {
              self.$router.go(-1)
            }
          }
          // this.$router.push({ path: "/post-login", params: {} });
        }).catch(e => {
          this.errors.push(e)
        })
    },
    get_stats_list() {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      const send_data = {
        ExpertId: user_id,
        RequestId: this.$route.params.rec_id,
      }
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/GetStatusListForTech', send_data, skeletonSilentRequest)
        .then(response => {
          response.data.StatusList.forEach(function (number) {
            var obj = { value: number.Id, label: number.StateName }
            self.status_list_items.push(obj)
          })
          self.selected_status_for_change = self.status_list_items[0].value;

        }).catch(e => {
          this.errors.push(e)
        })
    },
    add_informher_master() {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      const send_data = {
        UserId: user_id,
        RequestId: this.$route.params.rec_id,
        ReqName: this.request_info.RequestName,
        BranchId: this.branch_id,
      }
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/AddMasterFacator', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            this.get_informher_master()
          }
          // this.$router.push({ path: "/post-login", params: {} });
        }).catch(e => {
          this.errors.push(e)
        })
    },
    change_tech_status() {
      var self = this;
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      const send_data = {
        UserId: user_id,
        ReqId: this.$route.params.rec_id,
        StatusId: this.selected_status_for_change,
        Desc: this.change_status_summary,
      }

      if (this.selected_status_for_change == 52 || this.selected_status_for_change == 83 || this.selected_status_for_change == 88) {
        const amount = this.parseAmountInput(this.change_status_price)
        if (amount === '') {
          bus.$emit('show_toast', [2000, "مبلغ را وارد کنید"])
          return
        }
        send_data.TotalAmount = amount
      } else {
        send_data.TotalAmount = "0"
      }
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/AddChangeStatusByTech', send_data, {})
        .then(response => {
          bus.$emit('show_toast', [2000, response.data.msg])
          self.change_status_dialog = false;
          self.selected_status_for_change = self.status_list_items[0].value
          self.change_status_summary = ""
          self.change_status_price = ""
          self.get_request_info()
          // this.$router.push({ path: "/post-login", params: {} });
        }).catch(e => {
          this.errors.push(e)
        })
    },
    go_to_categories() {
      var self = this
      if (self.request_info.StatusId == self.request_statuses[2]) {
        self.action_button_text = self.$t('startToDelivery')
        self.next_action_status = self.request_statuses[3]
        self.get_last_user_location(this.next_action_status)

        return
      } else if (self.request_info.StatusId == self.request_statuses[3]) {
        self.action_button_text = self.$t('giveToCustomer')
        self.next_action_status = self.request_statuses[4]
      } else if (self.request_info.StatusId == self.request_statuses[4]) {
        self.action_button_text = ''
        self.next_action_status = 0
      } else if (self.request_info.StatusId == self.request_statuses[5]) {
        self.action_button_text = ''
        self.next_action_status = 0
      } else {
        self.action_button_text = ''
        self.next_action_status = 0
      }
      self.change_request_status(this.next_action_status)
    },
    go_to_goods_factors() {
      var self = this
      var passing_data = {
        category: 3,
        user: null,
        request: self.$route.params.rec_id,
        branch: this.branch_id,
        summary: "",
      }
      // var passing_data = JSON.parse(localStorage.getItem('request_data'));
      // passing_data.cat_id = item_id;
      localStorage.setItem("request_product", JSON.stringify(passing_data));
      console.log(passing_data)
      // this.dialog_factor = false
      this.$router.push({ name: 'ProductRequestFactors', params: { rec_id: this.$route.params.rec_id } })
      // var self = this
      // self.$router.push({ path: '/report-request/request-goods-factors/' + self.$route.params.rec_id })
    },
    go_to_qc() {

      this.$router.push({ name: 'RequestQualityControl', params: { rec_id: this.$route.params.rec_id } })
    },
    normalizePhoneDigits(value) {
      let phone = this.toEnglishDigits(String(value || '')).replace(/[^\d]/g, '')
      if (phone.startsWith('98') && phone.length > 10) phone = '0' + phone.substring(2)
      if (phone.startsWith('9') && phone.length === 10) phone = '0' + phone
      return phone
    },
    formatMobileNoForApi(value) {
      const phone = this.normalizePhoneDigits(value)
      return phone.startsWith('0') ? phone.substring(1) : phone
    },
    send_branch_address() {
      if (!this.showSendBranchAddressBtn) return
      const mobileNo = this.formatMobileNoForApi(this.request_info.CustomerMobile)
      if (!mobileNo) {
        bus.$emit('show_toast', [2000, 'شماره موبایل مشتری یافت نشد'])
        return
      }
      const send_data = {
        UserName: 'مشتری',
        MobileNo: mobileNo,
        TempId: '384118',
        UrlParam: this.branchAddressUrlParam,
      }
      this.axios.post('/SendPageUrl', send_data, {})
        .then(response => {
          if (response.data && response.data.error == 0) {
            bus.$emit('show_toast', [2000, response.data.msg || 'ارسال شد'])
          } else {
            bus.$emit('show_toast', [2000, (response.data && response.data.msg) || 'خطا در ارسال'])
          }
        })
        .catch(() => {
          bus.$emit('show_toast', [2000, 'خطا در ارسال'])
        })
    },
    go_to_informher_masters() {
      this.$router.push({ path: '/report-request/inform-her-masters/' + this.$route.params.rec_id })
    },
    get_device_status() {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      console.log()
      const send_data = {
        UserId: user_id,
      }
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/GetStatusSetting', send_data, skeletonSilentRequest)
        .then(response => {
          self.request_statuses = response.data.rslt

          if (self.request_info.StatusId == self.request_statuses[2]) {
            self.action_button_text = self.$t('startToDelivery')
            self.next_action_status = self.request_statuses[3]
          } else if (self.request_info.StatusId == self.request_statuses[3]) {
            self.action_button_text = self.$t('giveToCustomer')
            self.next_action_status = self.request_statuses[4]
          } else if (self.request_info.StatusId == self.request_statuses[4]) {
            self.action_button_text = ''
            self.next_action_status = 0
          } else if (self.request_info.StatusId == self.request_statuses[5]) {
            self.action_button_text = ''
            self.next_action_status = 0
          } else {
            self.action_button_text = ''
            self.next_action_status = 0
          }
        }).catch(e => {
          this.errors.push(e)
        })
    },
    change_request_status(status_id) {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      const send_data = {
        UserId: user_id,
        ReqId: this.$route.params.rec_id,
        Desc: '',
        StatusId: status_id,
      }
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/ChangeRequestStatus', send_data, {})
        .then(response => {
          self.get_request_info()
          if (status_id == self.request_statuses[4]) {
            // GetSignature.open(getActivity(), req_id, "5", 0, "", "0", 0);
            self.$router.push({ name: 'signature', params: { rec_id: self.$route.params.rec_id, type_id: 5 } })
          }
        }).catch(e => {
          this.errors.push(e)
        })
    },
    get_branch_permission() {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      var party_id = localStorage.getItem('party_id')

      const send_data = {
        UserId: user_id,
        Role: 'BranchDefinition',
        PartyId: party_id,
      }
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/ZkGetUserPermission', send_data, skeletonSilentRequest)
        .then(response => {
          if (response.data.error == 0) {
            this.branch_id = response.data.UserBranchId
          }
        }).catch(e => {
          this.errors.push(e)
        })
    },
    get_current_location() {
      var self = this

      // This will open permission popup
      navigator.geolocation.getCurrentPosition(function (position) {
        self.current_lat = position.coords.latitude;
        self.current_lng = position.coords.longitude;

      }, function (error) {
        console.log('error location is', error)
      });
    },
    get_last_user_location(status) {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId

      const send_data = {
        UserId: user_id,
      }
      // this.axios.post('/Register' , send_data,{
      this.axios.post('/GetLastLocationByUserId', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            self.source_location_lat = response.data.Lat;
            self.source_location_lng = response.data.Lng;
            // this.branch_id = response.data.UserBranchId
          } else {
            self.get_current_location();
            self.source_location_lat = self.current_lat;
            self.source_location_lng = self.current_lng;
          }
          self.get_snapp_price(status);

        }).catch(e => {
          console.log("error", e)
          this.errors.push(e)
        })
    },
    get_snapp_price(status) {
      var self = this

      self.source_location_lat = "35.732846"
      self.source_location_lng = "51.373192"
      if (self.source_location_lat == null || self.source_location_lat == "") {
        bus.$emit('show_toast', [1500, "موقعیت مکانی یافت نشد"])
        // return
      }
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId

      // const send_data = {
      //   source_lat: self.source_location_lat,
      //   source_lng: self.source_location_lng,
      //   dest_lat: self.request_info.Addresses[0].Lat,
      //   dest_lng: self.request_info.Addresses[0].Lng
      // }
      // console.log("send data snapp", send_data)

      // var config = {
      //   method: 'post',
      //   url: 'https://cp.zoodkomak.com/api/get_user_locations_price',
      //
      //   data: send_data
      // };
      var formData = new FormData();
      formData.append('source_lat', self.source_location_lat);
      formData.append('source_lng', self.source_location_lng);
      formData.append('dest_lat', self.request_info.Addresses[0].Lat);
      formData.append('dest_lng', self.request_info.Addresses[0].Lng);
      // console.log("send data snapp",send_data)
      var url = 'https://cp.zoodkomak.com/api/get_user_locations_price';
      // var config = {
      //   method: 'post',
      //   url: url,
      //
      //   data : send_data
      // };

      this.axios.post(url, formData, {})
        .then(function (response) {
          console.log(response.data.time);
          self.change_request_status_with_price(status, response.data.time, response.data.distance);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    change_request_status_with_price(status_id, price, distance) {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      const send_data = {
        UserId: user_id,
        ReqId: this.$route.params.rec_id,
        Desc: '',
        ReqType: 1,
        StatusId: status_id,
        SourceLat: self.source_location_lat,
        SourceLng: self.source_location_lng,
        DestLat: self.request_info.Addresses[0].Lat,
        DestLng: self.request_info.Addresses[0].Lng,
        RouteTime: price,
        Distance: distance,
      }

      // this.axios.post('/Register' , send_data,{
      this.axios.post('/ChangePreRequestStatusWithPrice', send_data, {})
        .then(response => {
          self.get_request_info()
          if (status_id == self.request_statuses[4]) {
            // GetSignature.open(getActivity(), req_id, "5", 0, "", "0", 0);
            self.$router.push({ name: 'signature', params: { rec_id: self.$route.params.rec_id, type_id: 5 } })
          }
        }).catch(e => {
          this.errors.push(e)
        })
    },
  }
}
</script>
<style scoped>
.request-detail-meta {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #111827;
  font-size: 13px;
  line-height: 1.4;
}

.request-detail-meta--mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}

.request-detail-meta__icon {
  flex-shrink: 0;
  width: 1rem;
  height: 1rem;
  color: #64748b;
}

.request_detail_ul {
  list-style: none;
  padding: 0;
  margin: 0 0 12px 0;
}

.request_detail_ul>li {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 12px 14px;
  margin-bottom: 8px;
}

.request_detail_ul>li:nth-child(even) {
  background: #e6f1ff;
  border: solid 1px #c4defe;
}

.request_detail_ul>li.request-detail-alert-company,
.request_detail_ul>li.request-detail-alert-company:nth-child(even) {
  background: #dc2626;
  border-color: #b91c1c;
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  justify-content: center;
}

/* For list items with label beside span */
.request_detail_ul>li:has(> label) {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* For list items with div containing label */
.request_detail_ul>li:has(> div) {
  display: block;
}

.request_detail_ul>li > div {
  width: 100%;
}

.request_detail_ul>li > div > label {
  display: block;
  color: #475569;
  font-size: 13px;
  margin-bottom: 8px;
}

.request_detail_ul>li label {
  color: #475569;
  font-size: 13px;
}

.request_detail_ul>li span {
  color: #0f172a;
  font-size: 13px;
}

.request_detail_ul>hr {
  display: none;
}

.address-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 10px;
}

.address-text {
  color: #0f172a;
}

.chip-btn {
  display: inline-block;
  padding: 8px 10px;
  border-radius: 20px;
  background: #eff6ff;
  color: #1d4ed8;
  border: 1px solid #bfdbfe;
  font-size: 12px;
}

.navigation-buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 12px;
}

.nav-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 16px;
  border-radius: 10px;
  background: #f0f9ff;
  border: 1px solid #bfdbfe;
  color: #1d4ed8;
  font-size: 13px;
  font-weight: 600;
  transition: all 0.2s;
}

.nav-btn:hover {
  background: #e0f2fe;
  border-color: #93c5fd;
}

.nav-btn:active {
  background: #dbeafe;
  transform: scale(0.98);
}

.nav-icon {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  object-fit: contain;
}

.pa-1 {
  padding: 0.25rem;
}

.mt-3 {
  margin-top: 0.75rem;
}

.primary-btn {
  padding: 12px;
  background: linear-gradient(135deg, #1c39bb, #2563eb);
  border: 0;
  border-radius: 12px;
  color: #fff;
  font-weight: 600;
}

.primary-btn--wide {
  grid-column: span 2;
}

.secondary-btn {
  padding: 12px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  font-weight: 600;
}

.actions-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  margin-top: 12px;
  padding-bottom: 70px;
}

.plain-dialog {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, .35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.dialog-card {
  width: 92%;
  max-width: 520px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, .18);
  overflow: hidden;
}

.dialog-header {
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
  font-weight: 700;
  text-align: center;
}

.dialog-body {
  padding: 12px 16px;
}

.dialog-actions {
  padding: 12px 16px;
  display: flex;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
}

.plain-input {
  width: 100%;
  min-height: 48px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 14px;
  color: #0f172a;
}

.btn-reject {
  padding: 12px;
  background: linear-gradient(135deg, #ef4444, #dc2626);
  color: #fff;
  border: none;
  border-radius: 12px;
  font-weight: 600;
}

.btn-info {
  padding: 12px;
  background: linear-gradient(135deg, #1c39bb, #2563eb);
  color: #fff;
  border: none;
  border-radius: 12px;
  font-weight: 600;
}

.btn-success {
  padding: 12px;
  background: linear-gradient(135deg, #10b981, #059669);
  color: #fff;
  border: none;
  border-radius: 12px;
  font-weight: 600;
}

.inline-refer-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  margin: 10px 0;
}

.inline-refer-header {
  padding: 10px 14px;
  font-weight: 700;
  background: linear-gradient(135deg, #1c39bb, #2563eb);
  color: #fff;
  text-align: center;
}

.inline-refer-body {
  padding: 12px 14px;
}

.btn-row {
  display: flex;
  gap: 8px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn-accept {
  padding: 10px 14px;
  background: linear-gradient(135deg, #1c39bb, #2563eb);
  color: #fff;
  border: none;
  border-radius: 10px;
  font-weight: 600;
}

.request-lightbox {
  z-index: 999;
  touch-action: none;
  cursor: zoom-out;
}

.request-lightbox__stage {
  max-height: calc(100vh - 8rem);
  max-width: 100%;
}

.request-lightbox__img {
  touch-action: none;
}

.skeleton-block {
  display: inline-block;
  vertical-align: middle;
  background-color: #e5e7eb;
  background-image: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.55) 45%,
    rgba(255, 255, 255, 0.65) 55%,
    rgba(255, 255, 255, 0) 100%
  );
  background-size: 200% 100%;
  animation: view-request-skeleton-shimmer 1.4s ease-in-out infinite;
}

.request_detail_ul>li .skeleton-block {
  font-size: 0;
  line-height: 0;
  color: transparent;
}

.skeleton-line {
  height: 0.75rem;
  border-radius: 6px;
}

.skeleton-line-sm {
  width: 5.5rem;
}

.skeleton-line-md {
  width: 8rem;
}

.skeleton-line-lg {
  width: 10rem;
  max-width: 70%;
}

.skeleton-line-full {
  display: block;
  width: 100%;
}

.skeleton-line-value {
  width: 7.5rem;
  flex-shrink: 0;
}

.skeleton-chip {
  width: 4.5rem;
  height: 1.5rem;
  border-radius: 0.5rem;
}

.skeleton-thumb {
  display: block;
  aspect-ratio: 1 / 1;
  border-radius: 0.5rem;
}

@keyframes view-request-skeleton-shimmer {
  100% {
    background-position: -200% 0;
  }
}
</style>
